package one.healthium.uscreen.domain.models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class BlockCondition(
    @SerialName("key") val key: String,
    @SerialName("eq") val eq: String? = null,
    @SerialName("neq") val neq: String? = null,
)
